import { Rate } from 'antd';

/**
 * V1.0.52: Reusable Rate component cho priorityLevel/importantLevel.
 * Gradient màu từ Vàng (1 sao) → Đỏ (5 sao) tương ứng mức độ tăng dần.
 *
 * Bảng màu (số sao đã chọn):
 *  1 ★  vàng tươi  #fadb14
 *  2 ★  vàng cam   #fa8c16
 *  3 ★  cam        #fa541c
 *  4 ★  đỏ cam     #f5222d
 *  5 ★  đỏ thẫm    #cf1322
 *
 * Sao chưa chọn: xám nhạt #e8e8e8
 */

/** Bảng màu gradient 5 cấp */
const LEVEL_COLORS = ['#fadb14', '#fa8c16', '#fa541c', '#f5222d', '#cf1322'];
const EMPTY_COLOR = '#e8e8e8';

/** Lấy màu của 1 sao tại index, theo value đã chọn */
export function getStarColor(index: number, value: number): string {
  // index 0-based; sao đã được "chọn" khi index < value
  if (index < value) {
    // Màu sao đã chọn dựa trên value tổng (toàn bộ cùng 1 màu = màu cấp đó)
    return LEVEL_COLORS[Math.min(value - 1, 4)];
  }
  return EMPTY_COLOR;
}

/** Lấy màu chính cho 1 mức độ (dùng cho badge, text) */
export function getLevelColor(value: number): string {
  return LEVEL_COLORS[Math.min(Math.max(value, 1) - 1, 4)];
}

export interface StarLevelRateProps {
  value?: number;
  onChange?: (value: number) => void;
  /** Tooltip array cho 5 mức */
  tooltips?: string[];
  /** Cỡ chữ sao (default 28) */
  size?: number;
  /** Read-only mode (Rate disabled) */
  disabled?: boolean;
}

export function StarLevelRate({
  value,
  onChange,
  tooltips,
  size = 28,
  disabled = false,
}: StarLevelRateProps) {
  return (
    <Rate
      count={5}
      value={value}
      onChange={onChange}
      disabled={disabled}
      tooltips={tooltips}
      character={({ index = 0 }) => (
        <span
          style={{
            fontSize: size,
            color: getStarColor(index, value ?? 0),
            transition: 'color 0.15s',
            lineHeight: 1,
          }}
        >
          ★
        </span>
      )}
    />
  );
}

/** Tooltips chuẩn cho "Gấp" */
export const URGENT_TOOLTIPS = ['Không gấp', 'Ít gấp', 'Bình thường', 'Gấp', 'Rất gấp'];

/** Tooltips chuẩn cho "Quan trọng" */
export const IMPORTANT_TOOLTIPS = ['Không quan trọng', 'Ít quan trọng', 'Bình thường', 'Quan trọng', 'Rất quan trọng'];
